// extracted by mini-css-extract-plugin
export default {"tablehead":"TableMaterialSubType_tablehead__IgSWv","custom-striped-table":"TableMaterialSubType_custom-striped-table__za5Go"};